import script from "./SlsLogQuery.vue?vue&type=script&setup=true&lang=js"
export * from "./SlsLogQuery.vue?vue&type=script&setup=true&lang=js"

import "./SlsLogQuery.vue?vue&type=style&index=0&id=50b708d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50b708d6"]])

export default __exports__